module.exports = __webpack_public_path__ + "assets/img/criancas.a54d2305.jpeg";